import React, { useState, useContext } from "react";
import { Navigate } from "react-router-dom";
import { UrlServicesContext } from "components/UrlServicesContext";

import { makeStyles } from "@mui/styles";
import { Button } from "reactstrap";
import {
  Slide,
  IconButton,
  Box,
  Grid,
  Snackbar,
  FormControl,
  TextField,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  Alert,
} from "@mui/material";
import axios from "axios";
import { Visibility, VisibilityOff } from "@mui/icons-material";

import {
  TitleTextPage,
  ParagraphTextPage,
  blackColor,
  cardBodyStyle,
  CircularProgressTheme,
} from "components/cardBodyStyle";

import PasswordRecovery from "../Dialog/PasswordRecovery";
import FrequentQuestions from "../Dialog/FrequentQuestions";

import logo from "assets/img/logo2.png";
import banner3 from "assets/img/banner3.png";

const useStyles = makeStyles(cardBodyStyle);

export default function CustomerLogin(props) {
  const classes = useStyles();

  const [loaderLogin, setLoaderLogin] = useState(false);
  const [passwordRecovery, setpasswordRecovery] = useState(false);
  const [alert, setAlert] = useState({
    openAlert: false,
    mensaje_error: "",
    loggedIn: localStorage.getItem("Session") === null ? false : true,
  });
  const [openFrequentQuestion, setOpenFrequentQuestion] = useState(false);

  const { urlServices, LoginAuth } = useContext(UrlServicesContext);

  const [values, setValues] = useState({
    mail: "",
    password: "",
    newPassword: "",
    userspass: "",
    showPassword: false,
    errorMail: false,
    errorPassword: false,
  });

  const submitFormLogin = () => (event) => {
    event.preventDefault();

    if (values.mail.length === 0) {
      setValues({
        ...values,
        errorMail: true,
      });
      setAlert({
        ...alert,
        openAlert: true,
        mensaje_error: "El campo Correo Electrónico es obligatorio.",
      });
    } else if (values.password.length === 0) {
      setValues({
        ...values,
        errorPassword: true,
      });
      setAlert({
        ...alert,
        openAlert: true,
        mensaje_error: "El campo contraseña es obligatorio.",
      });
    } else {
      setLoaderLogin(true);

      const data = {
        email: values.mail.trim(),
        password: values.password,
      };

      LoginServices(data);
    }
  };

  const handleChange = (prop) => (event) => {
    setAlert({
      ...alert,
      openAlert: false,
    });
    setValues({
      ...values,
      [prop]: event.target.value,
      errorMail: false,
      errorPassword: false,
    });
  };

  const handleClosePasswordRecovery = () => {
    setpasswordRecovery(false);
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleOpenPasswordRecovery = () => {
    setpasswordRecovery(true);
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ openAlert: false });
  };

  const LoginServices = (data) => {
    axios
      .post(`${urlServices}auth/login`, data)
      .then((response) => {
        if (response.status === 200) {
          if (response.data.data.status === 0) {
            setLoaderLogin(false);
            setAlert({
              ...alert,
              openAlert: true,
              mensaje_error: "Acceso deshabilitado del sistema.",
            });
          } else {
            LoginAuth(response.data); // SAVE SESSION

            const routePath =
              response.data.userType === "user"
                ? "/account/dashboard"
                : "/account/dashboard-customer";

            localStorage.setItem("controller", "/account");
            localStorage.setItem("controllerRouter", routePath);
            setAlert({ ...alert, loggedIn: true });
          }
        }
      })
      .catch((e) => {
        if (e.response === undefined) {
          setLoaderLogin(false);
          setAlert({
            ...alert,
            openAlert: true,
            mensaje_error: "Error de conexión, intente más tarde.",
          });
        } else if (e.response.status === 404) {
          setLoaderLogin(false);
          setValues({
            ...values,
            errorMail: true,
          });
          setAlert({
            ...alert,
            openAlert: true,
            mensaje_error: e.response.data.message,
          });
        } else if (e.response.status === 401) {
          setLoaderLogin(false);
          setValues({
            ...values,
            errorPassword: true,
          });
          setAlert({
            ...alert,
            openAlert: true,
            mensaje_error: e.response.data.message,
          });
        } else if (e.response.status === 500) {
          setLoaderLogin(false);
          setValues({
            ...values,
            errorPassword: true,
          });
          setAlert({
            ...alert,
            openAlert: true,
            mensaje_error: e.response.data.message,
          });
        }
      });
  };

  const handleCloseFrequentQuestion = () => {
    setOpenFrequentQuestion(false); // Close the modal
  };

  if (alert.loggedIn) {
    return (
      <Navigate
        from={localStorage.getItem("controller")}
        to={localStorage.getItem("controllerRouter")}
      />
    );
  }

  return (
    <Grid container sx={{ height: "100vh" }}>
      <Grid item xs={12} md={12}>
        <Box
          sx={{
            height: "100%",
            width: "100%",
            position: "relative", // Necesario para el pseudo-elemento
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundImage: `
        linear-gradient(rgba(255, 255, 255, 0.4), rgba(0, 0, 0, 0.6)),
        url(${banner3})
      `,
              backgroundSize: "cover",
             // backgroundPosition: "center",           
              zIndex: 1,           
            },
          }}
        >
          <Box
            sx={{
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              px: 2,
              position: "relative", // Para que esté encima del pseudo-elemento
              zIndex: 2,
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: 450,
                backgroundColor: "rgba(255, 255, 255, 1)", // Fondo blanco con 80% de opacidad
                borderRadius: 4,
                p: 5,
                backdropFilter: "blur(5px)", // Efecto de desenfoque opcional }}
              }}
            >
              <center>
                <img
                  src={logo}
                  alt="logo"
                  style={{ width: 150, marginBottom: 30, marginTop: 10 }}
                />
                <br></br>
                <TitleTextPage style={{ fontSize: 18 }}>
                  Iniciar sesión
                </TitleTextPage>
              </center>
              <form onSubmit={submitFormLogin} style={{ marginTop: 20 }}>
                <TextField
                  id="outlined-basic"
                  label="Correo electrónico"
                  variant="outlined"
                  value={values.mail}
                  onChange={handleChange("mail")}
                  error={values.errorMail}
                  type="email"
                  autoComplete="off"
                  margin="dense"
                  fullWidth
                />
                <FormControl variant="outlined" fullWidth sx={{ m: "15px 0" }}>
                  <InputLabel htmlFor="outlined-adornment-password">
                    Contraseña
                  </InputLabel>
                  <OutlinedInput
                    id="outlined-adornment-password"
                    type={values.showPassword ? "text" : "password"}
                    value={values.password}
                    error={values.errorPassword}
                    onChange={handleChange("password")}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                          onMouseDown={handleMouseDownPassword}
                          edge="end"
                        >
                          {values.showPassword ? (
                            <Visibility
                              fontSize="small"
                              className={classes.iconInput}
                            />
                          ) : (
                            <VisibilityOff
                              fontSize="small"
                              className={classes.iconInput}
                            />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                    labelWidth={80}
                    label="Contraseña"
                  />
                </FormControl>
                <a
                  onClick={handleOpenPasswordRecovery}
                  style={{
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                >
                  <ParagraphTextPage
                    style={{
                      color: blackColor,
                      fontSize: 12,
                    }}
                  >
                    ¿Contraseña olvidada?
                  </ParagraphTextPage>
                </a>
                <center>
                  {loaderLogin ? (
                    <CircularProgressTheme style={{ marginTop: 40 }} />
                  ) : (
                    <Button
                      className="btn-round"
                      color="info"
                      size="lg"
                      style={{
                        marginTop: 40,
                        marginLeft: 10,
                        background: blackColor,
                        color: "#ffffff",
                        letterSpacing: ".011em",
                        fontFamily: "sans-serif",
                      }}
                      onClick={submitFormLogin()}
                      type="submit"
                    >
                      <b>Iniciar sesión</b>
                    </Button>
                  )}
                </center>
              </form>
            </Box>
          </Box>
        </Box>
        {/*<Grid item xs={12} md={12} sx={{ mt: 6 }}>
            <center>
              <span
                onClick={() => setOpenFrequentQuestion(true)}
                style={{
                  fontSize: 12,
                  textTransform: "none",
                  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                  fontWeight: 500,
                  lineHeight: 1.75,
                  color: "#000",
                  cursor: "pointer",
                  border: "1px solid dimgrey",
                  padding: "4px 10px",
                  borderRadius: 4,
                  marginRight: 8,
                }}
              >
                Terminos y condiciones - Políticas de protección de datos -
                Preguntas frecuentes
              </span>
            </center>
          </Grid>*/}
      </Grid>

      {alert.openAlert && (
        <Snackbar
          open={true}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleCloseAlert}
        >
          <Slide direction="up" in={true} mountOnEnter unmountOnExit>
            <Alert
              onClose={handleCloseAlert}
              severity="error"
              elevation={6}
              variant="filled"
            >
              {alert.mensaje_error}
            </Alert>
          </Slide>
        </Snackbar>
      )}

      {passwordRecovery && (
        <PasswordRecovery
          open={passwordRecovery}
          exit={handleClosePasswordRecovery}
        />
      )}
      {openFrequentQuestion && (
        <FrequentQuestions
          open={openFrequentQuestion}
          exit={handleCloseFrequentQuestion}
        />
      )}
    </Grid>
  );
}
